import React from 'react';
import { makeStyles } from '@material-ui/core';

import { useIntl } from 'ha/i18n';
import { HOME } from 'ha/constants/pageNames';

import { Button } from '@ha/dsl';
import { usePage } from 'ha/modules/Page/contexts/PageContext';
import { SmartTrack as Track } from 'ha/components/track/SmartTrack';

const useStyles = makeStyles(() => ({
  container: {
    textAlign: 'center',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
}));

export const PricingLink: React.FC = () => {
  const { T, urlResolver } = useIntl();
  const { name } = usePage();
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <Track name="Clicked PricingLink in NavBar" type="button">
        <Button
          color="inherit"
          data-test-locator="PricingLink Button"
          variant="text"
          href={urlResolver.getPricingTenantsUrl()}
          rel={name !== HOME ? 'no-follow' : ''}
        >
          {T('pricing_link')}
        </Button>
      </Track>
    </div>
  );
};
